import { getIngredients, getCurrentUserId } from 'store/storeValtio';
import * as mh from './medicationHelpers.js';
import * as gh from './generalHelpers.js';
import { IngredientData } from '../components/ingredients/IngredientData';
import { getMedsHistory } from 'store/storeValtio';
import { addIngredientToDb, addSupplementToDb, getSupplementFromDb } from 'store/localDb';
import moment from 'moment';

export function getMedsContainingIngredient(iId) {
    const ingredients = getIngredients();
    const iMeds = [];
    for ( var i = 0; i < ingredients.length; ++i) {
        const ing = ingredients[i];
        if (ing.DsldId === iId) {
            const med = mh.lookupMed(ing.medicationId);
            const mInfo = {
                name: med.name,
                quantity: ing.quantity,
                unit: ing.unit,
                labelId: ing.labelId,
                DsldId: iId,
                medicationId: med.medicationId
            };
            iMeds.push(mInfo);
        }
    }    
    return iMeds;
}

export function findIngredientDataNames(searchName) {
    if (!searchName) return [];
    const uname = searchName.toUpperCase();
    console.log('findIngredientDataNames', uname);
 
    let ingNames = [];

    IngredientData.forEach(sd => {
        const nu = sd.name.toUpperCase();
        if (nu.startsWith(uname)) {
            const item = {
                'id': sd.id.toString(),
                'name': sd.name,
                'altName': sd.altName,
                'source': sd.source,
                'class': sd.class,
                'type': sd.type,
                'displayName': nu
            }
            ingNames.push(item);
            //console.log('g-names', item);
        }
        const anu = sd.altName.toUpperCase();
        if (anu.startsWith(uname)) {
            const item = {
                'id': sd.id.toString(),
                'name': sd.name,
                'altName': sd.altName,
                'source': sd.source,
                'displayName': anu
            }
            ingNames.push(item);
        }
    });
 
    return ingNames;
}

export function getIngredient(iId) {
    const id = Number(iId);
    const ingredients = getIngredients();
    for ( var i = 0; i < ingredients.length; ++i) {
        const ing = ingredients[i];
        if (ing.id === id)  {
            return ing;
        }
    }    
    return null;
}

export function getIngredientByIngredientId(iId) {
    const id = Number(iId);
    const ingredients = getIngredients();
    for ( var i = 0; i < ingredients.length; ++i) {
        const ing = ingredients[i];
        if (ing.DsldId === id)  {
            return ing;
        }
    }    
    return null;
}

export function getAllIngredients() {
    let allIngredients = [];
    const ingredients = getIngredients();
    for ( var i = 0; i < ingredients.length; ++i) {
        const ing = ingredients[i];
        const newObj = {
            name: ing.name,
            labelId: ing.labelId,
            DsldId: ing.DsldId,
            medicationId: ing.medicationId,
            quantity: ing.quantity,
            unit: ing.unit,
            category: ing.category,
            notes: ing.notes
        };
        allIngredients.push(newObj);
    }
    return allIngredients;
}

export function getAllIngredientsUnique() {
    let allIngredients = [];
    const ingredients = getIngredients();
    for ( var i = 0; i < ingredients.length; ++i) {
        const ing = ingredients[i];
        const iId = ing.DsldId;
        const medId = ing.medicationId;
        //console.log('ing', ing);
        var found = false;

        // check to see if we already have this ingredient
        for ( var j = 0; j < allIngredients.length; ++j) {
            if (allIngredients[j].DsldId === iId) {
                allIngredients[j].medicationId.push(medId);
                found = true;
                //console.log('found', allIngredients[j]);
                break;
            }
        }
        if (!found) {
            //console.log('gid', ing);
            const newObj = {
                labelId: ing.labelId,
                DsldId: ing.DsldId,
                medicationId: [ing.medicationId],
                quantity: ing.quantity,
                unit: ing.unit,
                name: ing.name,
                category: ing.category,
                notes: ing.notes
            };
            allIngredients.push(newObj);
        }
    }

    //console.log('allIngredients',allIngredients);
    return allIngredients;
}

// get Data for all the ingredients used by medId
export function getIngredientsForMedId(medId) {
    let medIngredients = [];
    const ingredients = getIngredients();
    //console.log('getIngredientsForMedId', medId, ingredients);
    for ( var i = 0; i < ingredients.length; ++i) {
        const ing = ingredients[i];
        if (ing.medicationId === medId) {
            //const iData = getIngredientData(ing.DsldId);
            const newObj = {
                id: ing.id,
                DsldId: ing.DsldId,
                medicationId: ing.medicationId,
                labelId: ing.labelId,
                quantity: ing.quantity,
                unit: ing.unit,
                name: ing.name,
                category: ing.category,
                notes: ing.notes
                //altName: iData.altName,
                //type: iData.type,
                //source: iData.source,
                //class: iData.class
            };
            medIngredients.push(newObj);
        }
    }    
    return medIngredients;
}

export function stringNullOrEmpty(s) {
    if (s===null || s.trim() === '') return true;
    return false;
}

// get the specific ingredient amounts used by medId for a given ingredient
export function getIngredientForMedId(medId, iId, uniiCode) {
    const ingredients = getIngredients();
    //console.log('getIngredientForMedId', medId, iId, ingredients);
    for ( var i = 0; i < ingredients.length; ++i) {
        const ing = ingredients[i];
        if (ing.medicationId === medId ) {
            if (stringNullOrEmpty(ing.uniiCode)) {
                if (ing.DsldId === iId) {
                    return ing;
                }
            } else {
                if (ing.uniiCode === uniiCode) {
                    return ing;
                }
            }
        }
    }    
    return null;
}

export function formatDosage(ing) {
    const str = ing.quantity.toFixed(1) + ' ' + ing.unit;
    return str;
}

export function formatDisplayName(i) {
    let str = i.name;
    str = str.replace(" (unspecified)", "");
    return str;
}

export function ingredientConsumption(mInfo, ing) {
    var today = 0;
    var yesterday = 0;
    var sevenDays = 0;
    var thirtyDays = 0;
    var todayUnits = '';
    var yesterdayUnits = '';
    var sevenDaysUnits = '';
    var thirtyDaysUnits = '';
    const todayJD =  gh.getJD(moment())
    const medsHistory = getMedsHistory();
    const iId = ing.DsldId;
    const uniiCode = ing.uniiCode;
    //console.log('ingredientConsumption', mInfo, ing);

    // for each medication that uses the ingredient
    let medIx = [];
    mInfo.forEach((m) => {
        medIx.push(m.medicationId);
    });
    //console.log('medIx', medIx);

    let mgUnits = false;
    let lUnits = false;
    let IUUnits = false;

    medIx.forEach((mId) => {
        // get the dose for this ingredient in this med
        const mI = getIngredientForMedId(mId, iId, uniiCode);
        //console.log('mI', mId, iId, uniiCode, mI);
        const dose = mI.quantity;
        const unit = mI.unit.toLowerCase();

        if (['mg', 'mcg'].includes(unit)) mgUnits = true;
        if (['ml', 'l'].includes(unit)) lUnits = true;
        if (['iu'].includes(unit)) IUUnits = true;

        // normalize the doseage to mcg and ml
        var qty;
        if (mI.unit === 'mg' ) qty = dose * 1000; // micrograms
        else if (mI.unit === 'l' ) qty = dose * 1000; // milliliters
        else qty = dose;
        //console.log('quantity', qty);

        // get the history for that medication
        let hist = medsHistory.filter((h) => h.medicationId === mId);
        hist.forEach((h,ix) => {
            //console.log('hist', h);
            const c = h.quantity;
            const taken = moment(h.date);
            const takenJD = gh.getJD(taken);
            const days = todayJD - takenJD;
            //console.log('days', days);

            // dose is the quantity time the amount taken
            if (days === 0) today += (c * qty);
            else if (days === 1) yesterday += (c * qty);
            if (days < 6) sevenDays += (c * qty);
            if (days < 29) thirtyDays += (c * qty);
        });
    });


    //console.log('Consumption', today, yesterday, sevenDays, thirtyDays);

    let units = '';
    let divisor = 1;
    if (mgUnits) {units = 'mg'; divisor = 1000}
    else if (lUnits) {units = 'ml'; divisor = 1}
    else if (IUUnits) {units = 'UI'; divisor = 1};

    const totals = {
        today: today / divisor, 
        yesterday: yesterday / divisor, 
        sevenDays: sevenDays / divisor, 
        thirtyDays: thirtyDays / divisor,
        units: units
    }
    return (totals);
}

export async function addIngredientsToMed(med, label) {
    if (!label) return (-1);
    if (!label.ingredients) return (-1);
    if (label.ingredients.length === 0) return 0;
    const count = label.ingredients.length;
    console.log('ingredients to add:', count, med.name, label.labelId);
  
    // see if we already have the supplement in the db
  
    const userId = getCurrentUserId();
    let data = null;
    const sup = await getSupplementFromDb(label.labelId, userId);
    console.log('getSupplementFromDb', label.labelId, sup);
    if (!sup) {
      console.log('sup not in DB', label.labelId);
      const newSupp = {
        userId: userId,
        labelId: label.labelId,
        name: label.name,
        brand: label.brand,
        contents: label.contents,
        quantity: Number(label.quantity),
        servingSize: Number(label.servingSize),
        unit: label.unit,
        entryDate: label.entryDate,
        sku: label.sku
      };
  
      console.log('addSupplementToDb', newSupp);
      addSupplementToDb(newSupp)
        .then((result)=>{
          console.log('supplement added', result);
        })
      data = newSupp;
    } else {
      console.log('supplement exists', label.labelId);
      data = label;
    }
  
    // add the ingredients for the medication
  
    for ( let x = 0; x < label.ingredients.length; ++x ) {
      const i = label.ingredients[x];
      console.log('adding ingredient to med', i.name);
      // check if already in DB
  
      const ing = findIngredient(userId, med.medicationId, i.uniiCode);
      if (!ing) {
        const newI = {
          userId: userId,
          medicationId: med.medicationId,
          uniiCode: i.uniiCode,
          DsldId: Number(i.ingredientId),
          labelId: Number(label.labelId),
          name: i.name,
          category: i.category,
          quantity: Number(i.quantity),
          unit: i.unit,
          notes: i.notes,
        };
  
        console.log('adding ingredient', newI.DsldId, newI.name);
        addIngredientToDb(newI)
          .then((result => {
            console.log('ingredient added', result);
          }))
      } else {
        console.log('ingredient exists', ing);
      }
    };
    console.log('ingredients added to med');
  }
  
  export function findIngredient(user, mId, iId) {
    const ing = getIngredients();
    for (let ix = 0; ix < ing.length; ++ix) {
      const i = ing[ix];
      if (i.user === user && i.medicationId === mId && i.uniiCode === iId) {
        return (i);
      }
    }
    return null
  }
